import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components/index"
import Button from "../button"
import Player from "@vimeo/player"
import Image from "../image"

import SbImageService from "../../helpers/SbImageService"

class Hero extends Component {
  state = {
    displayVideo: false,
  }

  closeVideo = () => {
    const { displayVideo } = this.state
    const { blok } = this.props

    if (blok.video && displayVideo) {
      if (blok.video.includes("vimeo")) {
        const iframe = document.querySelector("iframe")
        const player = new Player(iframe)

        player.pause()
      }

      this.setState({
        displayVideo: !displayVideo,
      })
    }
  }

  openVideo = () => {
    const { displayVideo } = this.state
    const { blok } = this.props

    if (blok.video && !displayVideo) {
      if (blok.video.includes("vimeo")) {
        const iframe = document.querySelector("iframe")
        const player = new Player(iframe)

        player.play()
      }

      this.setState({
        displayVideo: !displayVideo,
      })
    }
  }

  render() {
    const { displayVideo } = this.state
    const { blok, className } = this.props

    return (
      <SbEditable content={blok}>
        <div
          className={`hero animated ${
            blok.is_program ? " hero--program" : ""
          } `}
        >
          <div className="hero__container container">
            <div
              className="hero__image-container"
              style={{
                backgroundImage: `url("${SbImageService(blok.image)}")`,
              }}
            >
              {blok.video && (
                <div
                  className={`hero__video${
                    displayVideo ? " hero__video--visible" : ""
                  }`}
                >
                  <Button
                    onClick={this.closeVideo}
                    className="hero__video-close btn--cta"
                    text="Close Video"
                    iconName="X"
                  />
                  <iframe
                    title="Video"
                    className="hero__video-player"
                    src={
                      blok.video.includes("youtube")
                        ? `${blok.video}/&modestbranding=1&rel=0`
                        : blok.video
                    }
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              )}

              <div
                className={`hero__card card card--pd-md offset offset--bl-md ${
                  blok.card_height ? blok.card_height : className
                }`}
              >
                {blok.primary_cta &&
                  blok.primary_cta.map((content) =>
                    React.createElement(Components(content.component), {
                      key: content._uid,
                      blok: content,
                      className: "hero__btn btn--cta",
                    })
                  )}
                <div className="hero__card-content">
                  <h1 className="hero__heading heading--accent">
                    {blok.title}
                  </h1>
                  <p>{blok.description}</p>
                  <div className="hero__actions">
                    {!blok.video ? (
                      <>
                        {blok.secondary_cta &&
                          blok.secondary_cta.map((content) =>
                            React.createElement(Components(content.component), {
                              key: content._uid,
                              blok: content,
                              className: "hero__action-btn btn--sm-wide",
                            })
                          )}
                      </>
                    ) : (
                      <>
                        {blok.secondary_cta &&
                          blok.secondary_cta.map((content) => (
                            <Button
                              key={content._uid}
                              text={content.label}
                              className="hero__action-btn btn--sm-wide"
                              iconName={content.icon}
                              onClick={this.openVideo}
                              accessibility_title={blok.accessibility_title}
                            />
                          ))}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {blok.shape && (
                <Image
                  blok={{
                    image: blok.shape,
                    alt: blok.title,
                    title: blok.title,
                  }}
                  className="hero__shapes offset offset--br-md"
                />
              )}
            </div>
          </div>
        </div>
      </SbEditable>
    )
  }
}

Hero.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.arrayOf(PropTypes.object),
    image: PropTypes.string,
    video: PropTypes.string,
    blob: PropTypes.string,
    primary_cta: PropTypes.arrayOf(PropTypes.object),
    secondary_cta: PropTypes.arrayOf(PropTypes.object),
    card_height: PropTypes.string,
    is_program: PropTypes.bool,
  }).isRequired,
}

export default Hero
